import { Injectable      } from '@angular/core';
import { UtilsManager    } from 'src/app/managers/utils/utils.manager';
import { NotifierManager } from 'src/app/managers/notifier/notifier.manager';
import { Notifier        } from 'src/app/enums/notifier/notifier.enum';
import { NotifierMessage } from 'src/app/enums/notifier/message/notifier.enum';
import { RequestManager  } from 'src/app/managers/request/request.manager';
import { ErrorManager    } from 'src/app/managers/error/error.manager';
import { Device          } from 'src/app/beans/device/device.bean';
import { DeviceDetail } from 'src/app/beans/device/device.detail.bean';

@Injectable({
  providedIn: 'root'
})
export class DeviceHandler
{
    constructor
    (
      private _utils    : UtilsManager    ,
      private _notifier : NotifierManager ,
      private _request  : RequestManager  ,
      private _error    : ErrorManager
    ) {}

    async list( token: string, siteId: number, type: number, enabled: number )
    {      
        if ( !this._utils.checker().isValidText( token ) ) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING                  , 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        } 

        if ( !this._utils.checker().isValidId( siteId ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SITE_ID
          )
          return undefined
        }

        try
        {
          let response  = await this._request.device().list( token, siteId, type, enabled ).toPromise()

          if ( this._error.hasError( response ) )
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response ) 
          }

          return response as Device[]

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async update( token: string, deviceId: number, data: DeviceDetail )
    {      
      if ( !this._utils.checker().isValidId( deviceId ) ){
        this._notifier.show
        ( 
          Notifier.WARNING, 
          NotifierMessage.INVALID_DEVICE_ID
        )
        return undefined
      }
      
      if ( !this._utils.checker().isValidText( data.deviceName ))
      {
        this._notifier.show
        ( 
          Notifier.WARNING, 
          NotifierMessage.INVALID_DEVICE_NAME
        )
        return undefined
      }

      if ( !this._utils.checker().isValidText( data.deviceName ) && data.type == 20)
      {
        this._notifier.show
        ( 
          Notifier.WARNING, 
          NotifierMessage.INVALID_COUNTER_NAME
        )
        return undefined
      }

      if ( !this._utils.checker().isValidText( data.speechMessage ) && data.speech == 1)
      {
        this._notifier.show
        ( 
          Notifier.WARNING, 
          NotifierMessage.INVALID_SPEECH_COUNTER_MSG
        )
        return undefined
      }

      if ( !this._utils.checker().isValidText( data.speechCounter ) && data.speech == 1)
      {
        this._notifier.show
        ( 
          Notifier.WARNING, 
          NotifierMessage.INVALID_SPEECH_COUNTER_NAME
        )
        return undefined
      }

        try
        {
          let response = await this._request.device().update( token, deviceId, JSON.stringify(data)).toPromise()

          if ( this._error.hasError( response ) )
          {
            return this._error.handleCQWebapp ( response ) 
          }
          else
          {
            this._notifier.show
            ( 
              Notifier.SUCCESS, 
              NotifierMessage.OPERATION_OK
            )
            return response
          }

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async create( token: string, siteId: number, data: DeviceDetail )
    {      
        if ( !this._utils.checker().isValidText( token )) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING                  , 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        }
        
        if ( !this._utils.checker().isValidText( data.deviceName ))
        {
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_DEVICE_NAME
          )
          return undefined
        }

        if ( !this._utils.checker().isValidText( data.deviceName ) && data.type == 20)
        {
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_COUNTER_NAME
          )
          return undefined
        }

        if ( !this._utils.checker().isValidText( data.speechMessage ) && data.speech == 1)
        {
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SPEECH_COUNTER_MSG
          )
          return undefined
        }

        if ( !this._utils.checker().isValidText( data.speechCounter ) && data.speech == 1)
        {
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SPEECH_COUNTER_NAME
          )
          return undefined
        }

        if ( !this._utils.checker().isValidId( siteId ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SITE_ID
          )
          return undefined
        }

        try
        {
          let response  = await this._request.device().create( token, siteId, JSON.stringify(data)).toPromise()

          if ( this._error.hasError( response ) )
          {
            return this._error.handleCQWebapp ( response ) 
          }
          else
          {
            this._notifier.show
            ( 
              Notifier.SUCCESS, 
              NotifierMessage.OPERATION_OK
            )
            return response
          }

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async activation(token: string, deviceDetail: DeviceDetail) 
    {
      if(!this._utils.checker().isValidText(token)) 
      {
        this._notifier.show
        ( 
          Notifier.WARNING                 , 
          NotifierMessage.TOKEN_HAS_EXPIRED
        )
        return undefined
      } 

      try
      {
        let response = await this._request.device().activation(token, deviceDetail.id).toPromise()

        if(this._error.hasError(response))
        {
          return this._error.handleCQWebapp(response) 
        }

        return response
      }
      catch( error )
      {
        // this._error.handleNetwork ( error )  
        return undefined
      }
    }

    async detail( token: string, deviceId: number )
    {      
        if ( !this._utils.checker().isValidText( token ) ) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING                , 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        } 

        if (!this._utils.checker().isValidId( deviceId ))
        {
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_DEVICE_ID
          )
          return undefined
        }

        try
        {
          let response  = await this._request.device().detail( token, deviceId ).toPromise()

          if ( this._error.hasError( response ) )
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response ) 
          }

          return response

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async calendar( token: string, deviceId: number )
    {      
        if ( !this._utils.checker().isValidText( token ) ) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        } 

        if ( !this._utils.checker().isValidId( deviceId ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_DEVICE_ID
          )
          return undefined
        }

        try
        {
          let response  = await this._request.device().calendar( token, deviceId ).toPromise()

          if ( this._error.hasError( response ) )
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response ) 
          }

          return response

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async getDeviceService( token: string, siteId: number, deviceId: number )
    {      
        if ( !this._utils.checker().isValidText( token ) ) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        }

        if ( !this._utils.checker().isValidId( siteId ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SITE_ID
          )
          return undefined
        }

        if ( !this._utils.checker().isValidId( deviceId ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_DEVICE_ID
          )
          return undefined
        }

        try
        {
          let response = await this._request.device().getDeviceService( token, siteId, deviceId ).toPromise()

          if ( this._error.hasError( response ) )
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response ) 
          }
          
          return response 

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async updateDeviceService( token: string, siteId: number, serviceId: number, deviceId: number, set: number )
    {      
        if ( !this._utils.checker().isValidText( token ) ) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING                  , 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        }

        if ( !this._utils.checker().isValidId( siteId ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SITE_ID
          )
          return undefined
        }

        if ( !this._utils.checker().isValidId( serviceId ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SERVICE_ID
          )
          return undefined
        }

        if ( !this._utils.checker().isValidId( deviceId ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_DEVICE_ID
          )
          return undefined
        }

        try
        {
          let response  = await this._request.device().updateDeviceService( token, siteId, serviceId, deviceId, set ).toPromise()

          if ( this._error.hasError( response ) )
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response ) 
          }
          else
          {
            this._notifier.show
            ( 
              Notifier.SUCCESS            , 
              NotifierMessage.OPERATION_OK
            )
            return response
          }

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async updateCalendar( token: string, deviceId: number, calendarId: number, dow: number, open: string, close: string )
    {      
        if ( !this._utils.checker().isValidText( token ) ) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        } 

        if ( !this._utils.checker().isValidId( deviceId ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SERVICE_ID
          )
          return undefined
        }

        if ( !this._utils.checker().isValidDow( dow ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_CALENDAR_DOW
          )
          return undefined
        }

        if ( !this._utils.checker().isValidText( open ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_CALENDAR_OPEN
          )
          return undefined
        }

        if ( !this._utils.checker().isValidText( close ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_CALENDAR_CLOSE
          )
          return undefined
        }

        const open_time   = this._utils.time().timeToDate  (open  )
        const close_time  = this._utils.time().timeToDate  (close )
        
        if ( close_time < open_time ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_CALENDAR_TIME
          )
          return undefined
        }

        try
        {
          const response = await this._request.device().updateCalendar( token, deviceId, calendarId, dow, open, close ).toPromise()

          if ( this._error.hasError( response ) )
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response ) 
          }
          else 
          {
            this._notifier.show
            ( 
              Notifier.SUCCESS            , 
              NotifierMessage.OPERATION_OK
            )
            return response
          }

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async deleteTime( token: string, deviceId: number, calendarId: number, timeId: number )
    {      
        if ( !this._utils.checker().isValidText( token ) ) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        } 

        if ( !this._utils.checker().isValidId( deviceId ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SERVICE_ID
          )
          return undefined
        }

        if ( !this._utils.checker().isValidId( calendarId ) ){
          this._notifier.show
          ( 
            Notifier.ERROR                     , 
            NotifierMessage.INVALID_CALENDAR_ID
          )
          return undefined
        }

        if ( !this._utils.checker().isValidId( timeId ) ){
          this._notifier.show
          ( 
            Notifier.ERROR                 , 
            NotifierMessage.INVALID_TIME_ID
          )
          return undefined
        }

        try
        {
          const response = await this._request.device().deleteTime( token, deviceId, calendarId, timeId ).toPromise()

          if ( this._error.hasError( response ) )
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response ) 
          }
          else
          {
            this._notifier.show
            ( 
              Notifier.SUCCESS            , 
              NotifierMessage.OPERATION_OK
            )
            return response
          }

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async calendarStatus( token: string, deviceId: number, calendarId: number, timeId: number, enabled: number )
    {      
        if ( !this._utils.checker().isValidText( token ) ) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        } 

        if ( !this._utils.checker().isValidId( deviceId ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SERVICE_ID
          )
          return undefined
        }

        if ( !this._utils.checker().isValidId( calendarId ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_CALENDAR_ID
          )
          return undefined
        }

        try
        {
          const response = await this._request.device().calendarStatus( token, deviceId, calendarId, timeId, enabled ).toPromise()

          if ( this._error.hasError( response ) )
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response ) 
          }
          else
          {
            this._notifier.show
            ( 
              Notifier.SUCCESS            , 
              NotifierMessage.OPERATION_OK
            )
            return response
          }

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }
}

